























































































//import {functions,firestore} from "@/scripts/firebase";
import { GroupData, NoticeProps, UserPublicProfile } from "@/scripts/datatypes";
import { Component,Mixins } from "vue-property-decorator";
import { ValidationObserver,ValidationProvider } from 'vee-validate'
import Common from '@/mixins/common'

//import { User } from 'firebase';
import Notice from '@/components/Notice.vue';
import PanelSelectUser from '@/components/PanelSelectUser.vue';

@Component({
  components: {
    Notice,
    PanelSelectUser
  }
})

export default class EditGroup extends Mixins(Common) {
  notice = {} as NoticeProps
  defaultGroupData: GroupData = {
    hostUids: undefined,
    guestUids: undefined,
    name: '',
    description: '',
    memberUids: undefined,
    disabled: false,
    deleted: false,
    memberMeta: {}
  }
  tIsShow = false
  sIsShow = false
  theGroupName = ''
  theGroup = {...this.defaultGroupData}
  initGroupData = {...this.defaultGroupData}
  isLoading = false

  get existGroup(){
    return !! this.theGroup.creationTime
  }

  get theGroupId(){
    return this.$route.params.groupId || ''
  }

  $refs!: {
    hosts: InstanceType<typeof ValidationProvider>;
    guests: InstanceType<typeof ValidationProvider>;
    validationObserver: InstanceType<typeof ValidationObserver>;
  }

  get hostUids(){
    if(Array.isArray(this.theGroup.hostUids)){
      this.$refs.hosts.validate()
    }
    return this.theGroup.hostUids
  }

  get guestUids(){
    if(Array.isArray(this.theGroup.guestUids)){
      this.$refs.guests.validate()
    }
    
    return this.theGroup.guestUids
  }

  get disabledAddGroup(){
    return this.theGroup.name === '' || ! this.theGroup.guestUids || this.theGroup.guestUids.length === 0  || ! this.theGroup.hostUids || this.theGroup.hostUids.length === 0 || JSON.stringify(this.theGroup) === JSON.stringify(this.initGroupData)
  }

  

  get theGroupDoc(){
    return this.$getGroupsColRef().doc(this.theGroupId)
  }

  onSelect(type: 'host' | 'guest', event: false | UserPublicProfile){
    if(event === false){
      if(type === 'host'){
        this.tIsShow = false
      }
      if(type === 'guest'){
        this.sIsShow = false
      }
      return
    }
    this.toggleGroupMember(event,type)
  }

  async editGroup(){
		try{
			this.notice = {
				isShow: false,
			}
		
      if(await this.$refs.validationObserver.validate()){
        this.$store.commit("setLoading",true);
        this.isLoading = true
        
        const data: GroupData = {
          ...this.theGroup
        }

        await this.$updateDoc(this.theGroupDoc,data)
        const theGroupData = await this.$waitUntilUpdatedForDoc(this.theGroupDoc)
        
        this.notice = {
          message: this.$t('editGroup.success') as string,
          isShow: true,
          duration: 0,
          type: {'is-success': true}
        }
        
        this.theGroupName = this.theGroup.name
        this.$refs.validationObserver.reset()
      }
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('editGroup.error') as string
      const errorMessage1 = this.$getErrorMessage(errorCode)

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
			
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  toggleGroupMember(user: string | UserPublicProfile, type: 'guest' | 'host'){

    const theUid = (typeof user === 'string') ? user : user.uid || ''

    const key = type + 'Uids' as 'guestUids' | 'hostUids'
    if(! this.theGroup[key]){
      this.theGroup[key] = []
    }

    if(this.theGroup[key] && this.theGroup[key]?.includes(theUid)){
      delete this.theGroup.memberMeta[theUid]
      this.theGroup[key] = this.theGroup[key]?.filter((uid) => {
        return uid !== theUid
      })
    }else{
      this.theGroup[key]?.push(theUid)
    }

    this.theGroup.memberUids = this.theGroup.hostUids?.concat(this.theGroup.guestUids || [])

    if(typeof user === 'object'){
      this.theGroup.memberMeta[theUid] = {
        ref: this.$getUserPublicProfileDocRef(theUid),
        displayName: user.displayName || '',
        lastName: user.lastName || '',
        firestName: user.firstName || '',
        lastNameYomigana: user.lastNameYomigana || '',
        firestNameYomigana: user.firstNameYomigana || ''
      }
    }
  }

  async created(){
    console.trace('created')

    this.$store.commit("setLoading",true);
    this.isLoading = true
      
    try{
      try{
        const theGroupDocData = await this.theGroupDoc.get()
        if(theGroupDocData.exists){
          this.theGroup = {...this.theGroup,...theGroupDocData.data()}
          this.initGroupData = {...this.theGroup}
        }

        if(! this.existGroup){
          throw Error()
        }
      }catch(error){
        this.notice = {
          message: this.$t('editGroup.noGroupFound') as string,
          isShow: true,
          duration: 0,
          type: {'is-danger': true}
        }
      }
      this.theGroupName = this.theGroup.name

    }catch(error){
      console.table(error)
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  destroyed() {
    console.trace('destroyed');
  }

}
